<template>
    <div color="danger" class="impersonation-alert rounded-none bg-rose-100 px-5 py-3 flex items-center gap-3 w-full">
        <div class="text-rose-500">
            <font-awesome-icon widthAuto :icon="faTriangleExclamation" />
        </div>
        <div class="text-sm flex flex-col gap-2 justify-between items-start md:flex-row md:grow md:items-center">
            <span data-test="impersonation-message"
                >You are impersonating <strong>{{ userName }}</strong>{{ teamRoleWording }} of
                <strong>{{ teamName }}</strong
                ><template v-if="context"
                    >, {{ context.role }} of {{ context.kind }} <strong>{{ context.name }}</strong></template
                ></span
            >
            <vx-button href="/kiosk/impersonation/stop" color="danger" size="sm">
                Stop Impersonating
                <font-awesome-icon widthAuto :icon="faSquareArrowUpLeft"></font-awesome-icon>
            </vx-button>
        </div>
    </div>
</template>

<script setup>
import { VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSquareArrowUpLeft, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const props = defineProps({
    userRole: {
        type: String,
        required: true,
    },
});

const userName = Spark.state.user.name;
const teamName = Spark.state.currentTeam.name;

const hasTeamRole = '' !== props.userRole && 'none' !== props.userRole;
const teamRoleWording = hasTeamRole ? `, ${props.userRole}` : '';

const { currentGroup, currentOrgUnit, roleOnCurrentGroup, roleOnCurrentOrgUnit } = useCurrentGroup();

const impersonatedContext = () => {
    if (currentGroup.value?.group_id) {
        return { kind: 'group', name: currentGroup.value.name, role: roleOnCurrentGroup };
    }

    if (currentOrgUnit.value?.id) {
        return { kind: 'OU', name: currentOrgUnit.value.name, role: roleOnCurrentOrgUnit };
    }

    return null;
};

const context = impersonatedContext();
</script>
